import React from 'react';
import { ArrowRight } from 'lucide-react';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiHero = ({ onOpenForm }) => {
  const { hero } = GEN_AI_CREATIVE_LANDING;

  return (
    <section className="relative overflow-hidden bg-white px-5 pb-12 pt-10 md:px-10 md:pb-16 md:pt-14 xl:px-[100px] xl:pb-20 xl:pt-16">
      <div className="mx-auto grid max-w-[1240px] items-center gap-10 md:grid-cols-2 md:gap-8">
        <div className="gen-ai-hero-copy relative z-10 order-2 md:order-1">
          <h1 className="text-[40px] font-bold uppercase leading-[1.1] tracking-[-0.02em] text-[#0b0b0b] md:text-5xl xl:text-[64px]">
            <span className="text-[#2b7afe]">{hero.eyebrow}</span>
            <br />
            {hero.titleLines[0]}
            <br />
            {hero.titleLines[1]}
          </h1>
          <p className="mt-5 max-w-[490px] text-base leading-[1.3] text-[#2f2f2f]/80 md:text-lg">
            {hero.description}
          </p>
          <button
            type="button"
            onClick={onOpenForm}
            className="mt-8 inline-flex items-center gap-3 rounded-2xl bg-[#2b7afe] px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-[#1f6ae8]"
          >
            {hero.cta}
            <ArrowRight className="h-[18px] w-[18px]" aria-hidden />
          </button>
        </div>

        <div className="gen-ai-hero-visual relative order-1 mx-auto aspect-square w-full max-w-[420px] md:order-2 md:max-w-none">
          <div
            className="gen-ai-hero-glow pointer-events-none absolute inset-[4%] rounded-[40%] opacity-90"
            aria-hidden
          />
          <div className="absolute inset-[12%] overflow-hidden rounded-[18%] border border-white/10 md:inset-[10%] md:rounded-[56px]">
            <img
              src={hero.photo}
              alt="Команда работает с Gen AI"
              className="h-full w-full object-cover object-center"
            />
          </div>
          <img
            src={hero.bulb}
            alt=""
            aria-hidden
            className="gen-ai-hero-float pointer-events-none absolute -right-2 top-0 w-[34%] max-w-[200px] md:right-0 md:top-[-2%]"
          />
          <img
            src={hero.key}
            alt=""
            aria-hidden
            className="gen-ai-hero-float-delayed pointer-events-none absolute bottom-[-2%] left-[8%] w-[28%] max-w-[180px] md:bottom-0 md:left-[6%]"
          />
        </div>
      </div>
    </section>
  );
};

export default GenAiHero;
